import { formatDate } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MuiInputDirective } from '@df/legacy/ui/form/mui-input.directive';
import { Login } from '@df/session/login/login.interfaces';
import { NUi } from '@df/ui/df-ui.config';
import { ICalendarDate } from '@df/ui/form/calendar.component.def';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { DatepickerComponent } from 'projects/app-default/src/app/ui/form/datepicker/datepicker.component';
import { InputWrapBodyDirective } from 'projects/app-default/src/app/ui/form/input-wrap-body.directive';
import { InputWrapComponent } from 'projects/app-default/src/app/ui/form/input-wrap.component';
import { FormWizardStepAbstract } from '../../../../../ui/form/wizard/step/form-wizard-step.abstract';
@Component({
    selector: 'login-form-trade-step-5',
    templateUrl: './login-form-trade-step-5.component.html',
    standalone: true,
    imports: [FormsModule, InputWrapComponent, InputWrapBodyDirective, MuiInputDirective, TranslationModule, DatepickerComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginFormTradeStep5Component extends FormWizardStepAbstract {
    @Input()
    data: Login.IRegisterFormData;
    dateOpened?: ICalendarDate;

    private uiConfig = inject(NUi.OPTIONS);
    readonly calendarOptions = {};
    valueChangeHandler(value: ICalendarDate): void {
        if (value) {
            this.data['date_opened'] = formatDate(value, this.uiConfig.date.format, this.app.data.locale);
            this.detectChanges();
        }
    }
}
